import { type EntityState } from '@ngrx/entity';

import { type TemplateConfigurationSetupStep } from '@blaze-dashboard/ai-chat-domain';

import { type ChatMessage, isClientId } from './chat.models';

export function pendingTemplateConfigurationSetupStep(
  state: EntityState<ChatMessage>,
): TemplateConfigurationSetupStep | undefined {
  const newest = newestPersistedMessage(state);
  if (newest?.$type !== 'assistant') {
    return undefined;
  }
  if (newest.confirmation) {
    return 'confirmation';
  }
  switch (newest.form?.questions[0]?.$type) {
    case 'radio':
      return 'single-choice';
    case 'checkbox':
      return 'multiple-choice';
    default:
      return undefined;
  }
}

export function newestPersistedMessage(state: EntityState<ChatMessage>): ChatMessage | undefined {
  const ids = state.ids as string[];
  for (let index = ids.length - 1; index >= 0; index--) {
    if (!isClientId(ids[index])) {
      return state.entities[ids[index]];
    }
  }
  return undefined;
}
